import React from 'react';
import moment from 'moment';
import { timezoneConstants } from '../../../constants';

const FormatedDate = ({ dateString }) => {
  // Parse the date string using Moment.js
  const date = moment(dateString, timezoneConstants.dateTimeFormatForServer);

  return (
    <div>
      <h1 className="font-30 fw-700 mb-0">{date.date()}</h1>
      <h5 className="font-18 mb-0">
        {date.format(timezoneConstants.monthYearWordFormat)} {/* Formats as "Jan 2024" */}
      </h5>
    </div>
  );
};

export default FormatedDate;